import { createWebHistory, createRouter, createWebHashHistory } from "vue-router";


import KindergartenPage from "../components/Pages/KindergartenPage";

import AboutPageFive from "../components/Pages/AboutPageFive";
import SuccessStoryPage from "../components/Pages/SuccessStoryPage";

import GalleryPage from "../components/Pages/GalleryPage";

import ContactPage from "../components/Pages/ContactPage";
import ErrorPage from "../components/Pages/ErrorPage";
import CoursesPageTwo from "../components/Pages/CoursesPageTwo";
import CoursesPageThree from "../components/Pages/CoursesPageThree";
import CoursesPageFour from "../components/Pages/CoursesPageFour";
import CoursesPageFive from "../components/Pages/CoursesPageFive";



const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: "/",
      name: "KindergartenPage",
      component: KindergartenPage
    },
    {
      path: "/hakkimizda",
      name: "AboutPageFive",
      component: AboutPageFive
    },
    {
      path: "/etkinliklerimiz",
      name: "CoursesPageFive",
      component: CoursesPageFive
    },
    {
      path: "/etkinliklerimiz/:id",
      name: "GalleryPage",
      component: GalleryPage
    },
    {
      path: "/siniflarimiz",
      name: "CoursesPageFour",
      component: CoursesPageFour
    },
    {
      path: "/kurslarimiz",
      name: "CoursesPageThree",
      component: CoursesPageThree
    },
    {
      path: "/bloglar",
      name: "CoursesPageTwo",
      component: CoursesPageTwo
    },
    {
      path: "/bloglar/:id",
      name: "SuccessStoryPage",
      component: SuccessStoryPage
    },

    {
      path: "/iletisim",
      name: "ContactPage",
      component: ContactPage
    },


    {
      path: "/:pathMatch(.*)*",
      name: "ErrorPage",
      component: ErrorPage
    },



  ],
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  console.log(to)
  document.title = to.name
  next()
})




export default router;
